export const GET_DAILY_DIARY_SLEEPS = 'GET_DAILY_DIARY_SLEEPS'
export const GET_DAILY_DIARY_SLEEPS_SUCCESS = 'GET_DAILY_DIARY_SLEEPS_SUCCESS'
export const GET_DAILY_DIARY_SLEEPS_FAILED = 'GET_DAILY_DIARY_SLEEPS_FAILED'

export const ADD_SLEEP_TO_LIST = 'ADD_SLEEP_TO_LIST'

export const CLEAR_DAILY_DIARY_SLEEPS = 'CLEAR_DAILY_DIARY_SLEEPS'
